// src/components/client/ClientTabs.js
import React from 'react';
import { NavLink, useLocation } from 'react-router-dom';

export default function ClientTabs({ counts = {} }) {
    const location = useLocation();
    const base = '/mon-compte';

    // Define tabs with their count key
    const tabs = [
        { to: `${base}`, label: 'Accueil', exact: true },
        { to: `${base}/profil`, label: 'Profil' },
        { to: `${base}/projets`, label: 'Projets', countKey: 'projects' },
        { to: `${base}/devis`, label: 'Devis', countKey: 'quotes' },
        { to: `${base}/factures`, label: 'Factures', countKey: 'invoices' },
        { to: `${base}/contrats`, label: 'Contrats', countKey: 'contracts' },
        { to: `${base}/rendez-vous`, label: 'Rendez-vous', countKey: 'meetings' },
        { to: `${base}/messages`, label: 'Messages', countKey: 'messages' },
    ];

    return (
        <div style={{ marginTop: 12, marginBottom: 12 }}>
            <style>{`
        .mc-tabs{ display:flex; flex-wrap:wrap; gap:8px; border-bottom:1px solid var(--border, #e5e7eb); justify-content:center; }
        .mc-tab{ display:inline-flex; align-items:center; gap:8px; padding:8px 12px; border:1px solid var(--border, #e5e7eb); border-bottom:none; border-radius:10px 10px 0 0; background:var(--surface, #fff); color:var(--text, #111827); text-decoration:none; position:relative; }
        .mc-tab:hover{ background: #f8fafc; }
        .mc-tab.active{ background:var(--card-bg, #fff); color:var(--text, #111827); box-shadow:0 -1px 0 0 var(--border, #e5e7eb) inset; border-bottom: 2px solid #6366f1; }
        .mc-badge{ background:#3b82f6; color:#fff; font-size:0.7rem; font-weight:700; padding:1px 6px; border-radius:999px; line-height:1.2; min-width:16px; text-align:center; }
        
        .dark .mc-tab{ background:#0b1220; color:#e5e7eb; border-color:#1f2937; }
        .dark .mc-tab:hover{ background:#111827; }
        .dark .mc-tab.active{ background:#0b1220; box-shadow:0 -1px 0 0 #1f2937 inset; border-bottom: 2px solid #6366f1; }
        .dark .mc-badge{ background:#2563eb; }
      `}</style>
            <div className="mc-tabs">
                {tabs.map(t => {
                    const count = t.countKey ? counts[t.countKey] : 0;
                    return (
                        <NavLink
                            key={t.to}
                            to={t.to}
                            end={t.exact}
                            className={({ isActive }) => `mc-tab ${isActive ? 'active' : ''}`}
                        >
                            {t.label}
                            {count > 0 && <span className="mc-badge">{count}</span>}
                        </NavLink>
                    );
                })}
            </div>
        </div>
    );
}
